<template>
  <nav
    aria-label="page navigation example"
    class="d-flex justify-content-center"
  >
    <p class="loadMore">
      <a
        class="btn btn-primary text-white"
        v-if="modelValue !== 1000"
        @click="increaseItems"
        ><i class="fa fa-chevron-down"></i> {{ $t('Show More') }}</a
      >
    </p>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ShowMoreButton',
  props: {
    modelValue: Number,
  },
  emits: ['update:modelValue'],
  methods: {
    increaseItems(): void {
      if (this.modelValue === 4) {
        this.$emit('update:modelValue', 12);
      } else if (this.modelValue === 12) {
        this.$emit('update:modelValue', 24);
      } else if (this.modelValue === 24) {
        this.$emit('update:modelValue', 1000);
      }
    },
  },
});
</script>
